import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useRef, useState } from 'react'

import DotsMenuHorizontalIcon from '../../../../../../assets/icons/dots-menu-horizontal.svg'
import { Localized } from '../../../../../../localization/react'
import ActionWrapper from '../components/ActionWrapper'

import SettingsActions from './SettingsActions'

const SettingsButton = () => {
  const containerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState<null | Element>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleDialog = () => {
    setAnchorEl(containerRef.current)
    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <ActionWrapper onClick={toggleDialog} forwardedRef={containerRef}>
        <Stack direction="row" alignItems="center" gap={2.5}>
          <Text variant="small" sx={{ color: 'black', display: { xs: 'none', md: 'initial' } }}>
            <Localized id="settings-button" />
          </Text>
          <Icon src={DotsMenuHorizontalIcon} size="small" color="midnight" />
        </Stack>
      </ActionWrapper>
      <SettingsActions anchorEl={anchorEl} isOpen={isModalOpen} toggleDialog={toggleDialog} />
    </>
  )
}

export default SettingsButton
